import {
  Customer,
  ValidateAskResetPasswordResponse,
  VerifyCustomerExistResponse,
  type LoginTypeProvider, HttpErrorMessageType
} from '@eo-storefronts/eo-core'
import { createState } from '~/src/hooks/useEoState'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'

export type AuthenticationFlowCustomer = Partial<Pick<
Customer,
'id' | 'uid' | 'phone' | 'email' | 'password' | 'firstName' | 'lastName' | 'company' | 'vatNumber' | 'locale'
>>

export interface AuthenticationFlowState {
  isLoading: boolean,
  errors: Record<string, HttpErrorMessageType[]> | string | null,
  loginType: 'email' | 'phone',
  type: LoginTypeProvider | 'PASSWORD_RESET' | null,
  previousStep: AuthenticationFlowDialogNameEnum | null,
  step: AuthenticationFlowDialogNameEnum,
  customer: AuthenticationFlowCustomer | null,
  missingFields: string[],
  password: string | null,
  confirmPassword: string | null,
  confirmationCode: string | null,
  confirmationCodeSentAt: string | null,
  loginTypeResponse: VerifyCustomerExistResponse | null,
  validateAskResetPasswordResponse: ValidateAskResetPasswordResponse | null,
}

export const authenticationFlowStateDefaultValue: AuthenticationFlowState = {
  isLoading: false,
  errors: null,
  loginType: 'email',
  type: null,
  previousStep: null,
  step: AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_LOGIN_TYPE_SELECTION,
  customer: null,
  missingFields: [],
  password: null,
  confirmPassword: null,
  confirmationCode: null,
  confirmationCodeSentAt: null,
  loginTypeResponse: null,
  validateAskResetPasswordResponse: null
}

export const authenticationFlowStateKey = 'authenticationFlowState'

export const AUTHENTICATION_FLOW_STATE = createState<AuthenticationFlowState>({
  key: authenticationFlowStateKey,
  default: authenticationFlowStateDefaultValue
})

export default AUTHENTICATION_FLOW_STATE
